/* Configurateur de poster d'album : bloc de la page produit.
   - recherche Spotify (un champ, ou artiste + album) via le serveur de rendu (data-api)
   - choix du fond ; l'aperçu en direct remplace la 1re image de la galerie du thème
   - ajoute les propriétés de ligne (Album, Fond, _album_id…) au formulaire d'achat existant
   Aucune dépendance. Le prix, la taille et le panier restent gérés par le thème. */
(function () {
  'use strict';

  var FALLBACK_FONDS = [
    { id: 'blanc', label: 'Blanc', swatch: '#FAF9F7' },
    { id: 'creme', label: 'Crème', swatch: '#F8F4EC' },
    { id: 'noir', label: 'Noir', swatch: '#0C0B0A' },
    { id: 'noir_degrade', label: 'Noir dégradé', swatch: 'linear-gradient(#5a3b2a,#0C0B0A)' }
  ];

  /* Ordre d'apparition des images de la galerie : poster à plat, puis mises en scène 1, 2, 3.
     Chaque image attend que celles qui la précèdent soient affichées (ou aient échoué) : le poster à plat ne peut plus
     s'afficher après une mise en scène. Pour changer l'ordre, modifier ce tableau. */
  var ORDRE = ['flat', 'm1', 'm2', 'm3'];

  /* Polices de signature : liste de repli si /api/options ne répond pas (mêmes identifiants que le serveur). */
  var FALLBACK_SIG_FONTS = [
    { id: 'caveat', label: 'Caveat' }, { id: 'dancing', label: 'Dancing Script' }, { id: 'aurore', label: 'La Belle Aurore' },
    { id: 'delafield', label: 'Mrs Saint Delafield' }, { id: 'sacramento', label: 'Sacramento' }, { id: 'vibes', label: 'Great Vibes' }
  ];
  var SIG_FORBIDDEN = /[^\p{L}\p{N} \-'.&,!?$]/gu;      // même filtre que le serveur (renderer.normalize_options)
  var HEX6 = /^#?[0-9a-f]{6}$/i;
  var CONTRAST_MIN = 1.3;                                  // rapport WCAG entre un rectangle modifié et le fond du poster

  /* Poster cover : la pochette telle quelle, ou en noir et blanc (id = paramètre « version » du serveur). */
  var COVER_VERSIONS = [
    { id: 'color', label: 'Couleur', swatch: 'linear-gradient(135deg,#e8a54b 0%,#c8453b 50%,#2f5d8a 100%)' },
    { id: 'bw', label: 'Noir et blanc', swatch: 'linear-gradient(135deg,#fff 50%,#111 50%)' }
  ];

  function PosterConfigurator(root) {
    var self = this;
    this.root = root;
    this.api = (root.dataset.api || '').replace(/\/+$/, '');
    this.mode = root.dataset.mode === 'double' ? 'double' : 'single';
    this.kind = root.dataset.kind === 'cover' ? 'cover' : 'fiche';   // cover : pochette seule, carrée, en couleur ou noir et blanc
    this.msgPick = root.dataset.msgPick || 'Choisissez d\'abord un album.';
    this.fontChoice = root.dataset.fontChoice === 'true';              // false : une seule police, pas de choix pour le client
    this.fontDefault = root.dataset.fontDefault || 'vibes';
    this.state = { album: null, fond: null, mode: 'code', sig: '', font: this.fontDefault, bar: null, barDefault: null };
    this.slot = null; this.cfg = null; this.cfgKey = ''; this.cfgTimer = null; this.cfgPromise = null; this.barKey = '';
    this.msgSignature = root.dataset.msgSignature || 'Saisissez le texte de la signature, ou choisissez le code Spotify.';
    this.labels = { code: root.dataset.labelCode || 'Code Spotify', signature: root.dataset.labelSignature || 'Signature', barAuto: root.dataset.labelBarAuto || 'Couleurs de la pochette' };
    this.msgContrast = root.dataset.msgContrast || '';
    this.$ = function (sel) { return root.querySelector(sel); };
    this.inputs = this.mode === 'double'
      ? { artist: this.$('[data-pc-artist]'), album: this.$('[data-pc-album]') }
      : { q: this.$('[data-pc-q]') };
    this.list = this.$('[data-pc-results]');
    this.msg = this.$('[data-pc-message]');
    this.selected = this.$('[data-pc-selected]');
    this.timer = null; this.ctrl = null; this.active = -1; this.pending = null; this.orig = null;
    if (!this.api) { this.say('Configurateur non configuré : adresse du serveur manquante.', true); return; }
    this.wake();
    this.initFonds();
    this.initSearch();
    if (this.kind !== 'cover') { this.initMode(); this.initBar(); }
    this.$('[data-pc-clear]').addEventListener('click', function () { self.reset(true); });
    // Sans album, l'achat est bloqué (capture : passe avant le gestionnaire de formulaire du thème).
    document.addEventListener('submit', function (e) {
      var form = self.form();
      if (!form || e.target !== form) { return; }
      if (!self.state.album) {
        e.preventDefault(); e.stopImmediatePropagation();
        self.say(self.msgPick, true);
        var first = self.firstInput(); if (first) { first.focus(); first.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        return;
      }
      var sigInput = self.$('[data-pc-sig-text]');
      if (self.kind !== 'cover' && self.state.mode === 'signature' && !self.state.sig.trim()) {
        e.preventDefault(); e.stopImmediatePropagation();
        self.say(self.msgSignature, true);
        if (sigInput) { sigInput.focus(); sigInput.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        return;
      }
      if (self.configBusy()) {                     // l'adresse d'impression signée est en cours de demande : on attend, puis on renvoie
        e.preventDefault(); e.stopImmediatePropagation();
        self.settleConfig().then(function () { if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); } });
        return;
      }
      self.syncProperties();                       // le thème peut avoir réécrit le formulaire : on réinscrit les propriétés
    }, true);
  }

  PosterConfigurator.prototype.firstInput = function () { return this.inputs.q || this.inputs.artist; };

  PosterConfigurator.prototype.form = function () {
    var forms = document.querySelectorAll('form[action$="/cart/add"]');
    // getAttribute : form.id serait masqué par le champ caché <input name="id"> du formulaire d'achat
    for (var i = 0; i < forms.length; i++) { if ((forms[i].getAttribute('id') || '').indexOf('installment') === -1) { return forms[i]; } }
    return null;
  };

  /* L'hébergement gratuit s'endort après un quart d'heure sans visite. Le thème le réveille dès l'arrivée sur le
     site (snippets/reveil-serveur.liquid) ; ici on suit son état pour informer le client si le démarrage est encore
     en cours, et on le garde éveillé tant que la page reste ouverte. */
  var TXT = {
    waking: 'Connexion au serveur… (jusqu\'à une minute la première fois)',
    awake: 'Serveur prêt.',
    searchSlow: 'Le serveur démarre, les résultats arrivent…',
    making: 'Création de votre poster…',
    makingSlow: 'Le serveur démarre, votre poster arrive dans quelques secondes…',
    ready: 'Vos aperçus sont prêts.'
  };

  PosterConfigurator.prototype.wake = function () {
    var self = this, slow = false;
    this.awake = false;
    var hint = setTimeout(function () { if (!self.awake && !self.msg.textContent) { slow = true; self.say(TXT.waking); } }, 2500);
    var ping = function (tries) {
      fetch(self.api + '/health', { cache: 'no-store' }).then(function (r) {
        if (!r.ok) { throw new Error('health'); }
        self.awake = true; clearTimeout(hint);
        if (slow && self.msg.textContent === TXT.waking) { self.flash(TXT.awake); }
      }).catch(function () { if (tries > 0) { setTimeout(function () { ping(tries - 1); }, 5000); } });
    };
    ping(12);
    setInterval(function () {                              // maintien en éveil : sans effet si l'onglet est en arrière-plan
      if (document.visibilityState === 'visible') { fetch(self.api + '/health', { cache: 'no-store' }).catch(function () {}); }
    }, 240000);
  };

  /* Message de confirmation : s'efface seul s'il n'a pas été remplacé entre-temps. */
  PosterConfigurator.prototype.flash = function (text) {
    var self = this;
    this.say(text);
    setTimeout(function () { if (self.msg.textContent === text) { self.say(''); } }, 2600);
  };

  PosterConfigurator.prototype.progress = function (done, total) {
    var bar = this.$('[data-pc-progress]');
    if (!bar) { return; }
    bar.hidden = !total;
    if (total) { bar.firstElementChild.style.width = Math.max(8, Math.round(done / total * 100)) + '%'; }
  };

  PosterConfigurator.prototype.say = function (text, error) {
    this.msg.textContent = text || '';
    this.msg.classList.toggle('pc-message--error', !!error);
  };

  /* ---------- fonds ---------- */
  PosterConfigurator.prototype.initFonds = function () {
    var self = this;
    var render = function (fonds) {
      var box = self.$('[data-pc-fonds]');            // le fieldset : ses <input>/<label> forment la grille du thème
      box.querySelectorAll('input, label').forEach(function (n) { n.remove(); });
      fonds.forEach(function (f, i) {
        var id = 'pc-fond-' + f.id + '-' + Math.random().toString(36).slice(2, 7);
        var input = document.createElement('input');
        input.type = 'radio'; input.name = 'pc-fond'; input.value = f.id; input.id = id; input.checked = i === 0;
        input.addEventListener('change', function () { self.state.fond = f; self.refresh(true); });
        var label = document.createElement('label');
        label.setAttribute('for', id);
        var dot = document.createElement('span'); dot.className = 'pc-dot'; dot.style.background = f.swatch;
        label.appendChild(dot); label.appendChild(document.createTextNode(f.label));
        box.appendChild(input); box.appendChild(label);
      });
      self.state.fond = fonds[0];
      self.refresh();
    };
    if (this.kind === 'cover') { render(COVER_VERSIONS); return; }   // pas de fonds : deux versions de la même pochette
    render(FALLBACK_FONDS);
    fetch(this.api + '/api/fonds').then(function (r) { return r.ok ? r.json() : null; })
      .then(function (f) { if (f && f.length) { render(f); } }).catch(function () {});
  };

  /* ---------- recherche ---------- */
  PosterConfigurator.prototype.params = function () {
    if (this.mode === 'double') {
      var a = this.inputs.artist.value.trim(), b = this.inputs.album.value.trim();
      if (a.length + b.length < 2) { return null; }
      return (a ? 'artist=' + encodeURIComponent(a) : '') + (a && b ? '&' : '') + (b ? 'album=' + encodeURIComponent(b) : '');
    }
    var q = this.inputs.q.value.trim();
    return q.length < 2 ? null : 'q=' + encodeURIComponent(q);
  };

  PosterConfigurator.prototype.initSearch = function () {
    var self = this;
    Object.keys(this.inputs).forEach(function (k) {
      var input = self.inputs[k];
      input.addEventListener('input', function () {
        clearTimeout(self.timer);
        if (self.state.album) { self.reset(false); }          // on retape : l'album choisi n'est plus valable
        var p = self.params();
        if (!p) { self.closeList(); return; }
        self.timer = setTimeout(function () { self.search(p); }, 300);
      });
      input.addEventListener('keydown', function (e) {
        var items = self.list.querySelectorAll('[role=option]');
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          if (!items.length) { return; }
          e.preventDefault();
          self.active = (self.active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
          items.forEach(function (el, i) { el.classList.toggle('is-active', i === self.active); });
        } else if (e.key === 'Enter') {
          if (self.active >= 0 && items[self.active]) { e.preventDefault(); items[self.active].click(); }
        } else if (e.key === 'Escape') { self.closeList(); }
      });
    });
    // Clic hors du bloc : referme la liste. On lit le chemin de l'evenement (fige au depart) et non
    // e.target.contains : un clic sur un artiste reconstruit la liste, l'element clique est alors retire
    // de la page et paraitrait « dehors ».
    document.addEventListener('click', function (e) {
      var path = e.composedPath ? e.composedPath() : [];
      if (path.indexOf(self.root) === -1 && !self.root.contains(e.target)) { self.closeList(); }
    });
  };

  /* Recherche : un champ unique interroge /api/find (artistes avec leurs abonnés, puis albums), comme
     le constructeur de design. Un clic sur un artiste liste tous ses albums ; un clic sur un album le
     charge directement. Deux champs séparés (artiste / album) ou serveur sans /api/find : recherche
     d'albums seule (/api/search). */
  PosterConfigurator.prototype.search = function (params, retries) {
    var self = this;
    if (this.ctrl) { this.ctrl.abort(); }
    this.ctrl = new AbortController();
    this.say('');
    this.list.innerHTML = '<li class="pc-result pc-result--info">Recherche…</li>';
    this.list.hidden = false;
    var q = this.mode === 'single' ? this.inputs.q.value.trim() : '';
    var signal = this.ctrl.signal;
    var slow = setTimeout(function () {
      var li = self.list.querySelector('.pc-result--info');
      if (!signal.aborted && li && self.list.children.length === 1) { li.textContent = TXT.searchSlow; }
    }, 2500);
    retries = retries || 0;
    var json = function (url) {
      return fetch(url, { signal: signal }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) { throw new Error(j.error || j.detail || 'Erreur'); } return j; });
      });
    };
    var classic = function () { return json(self.api + '/api/search?' + params).then(function (j) { self.showResults(j.results || []); }); };
    var run = q
      ? json(this.api + '/api/find?q=' + encodeURIComponent(q)).then(function (j) { self.showFind(j); }, function (err) {
          if (err.name === 'AbortError') { throw err; }
          return classic();
        })
      : classic();
    run.then(function () { clearTimeout(slow); }, function (err) {
      clearTimeout(slow);
      if (err.name === 'AbortError') { return; }
      if (err instanceof TypeError && retries < 6) {         // serveur injoignable : il démarre, on relance sans rien demander
        self.list.innerHTML = '<li class="pc-result pc-result--info"></li>';
        self.list.firstChild.textContent = TXT.searchSlow;
        self.timer = setTimeout(function () { if (self.params() === params) { self.search(params, retries + 1); } }, 5000);
        return;
      }
      self.closeList();
      self.say(err instanceof TypeError ? 'Le serveur ne répond pas. Réessayez dans un instant.' : 'Recherche impossible : ' + err.message, true);
    });
  };

  PosterConfigurator.prototype.addInfo = function (text) {
    var li = document.createElement('li');
    li.className = 'pc-result pc-result--info'; li.textContent = text;
    this.list.appendChild(li);
  };

  PosterConfigurator.prototype.addHead = function (text) {
    var li = document.createElement('li');
    li.className = 'pc-result pc-result--head'; li.setAttribute('role', 'presentation'); li.textContent = text;
    this.list.appendChild(li);
  };

  PosterConfigurator.prototype.addAlbum = function (a) {
    var self = this;
    var li = document.createElement('li');
    li.className = 'pc-result'; li.setAttribute('role', 'option');
    li.innerHTML = '<img alt="" width="44" height="44" loading="lazy"><span class="pc-result__text"><strong></strong><span></span></span>';
    if (a.thumb) { li.querySelector('img').src = a.thumb; } else { li.querySelector('img').remove(); }
    li.querySelector('strong').textContent = a.name;
    li.querySelector('.pc-result__text span').textContent = a.artist + (a.year ? ' · ' + a.year : '') + (a.type && a.type !== 'album' ? ' · ' + a.type : '');
    li.addEventListener('click', function () { self.choose(a); });
    this.list.appendChild(li);
  };

  PosterConfigurator.prototype.addArtist = function (a) {
    var self = this;
    var li = document.createElement('li');
    li.className = 'pc-result pc-result--artist'; li.setAttribute('role', 'option');
    li.innerHTML = '<img alt="" width="44" height="44" loading="lazy"><span class="pc-result__text"><strong></strong><span></span></span>';
    if (a.thumb) { li.querySelector('img').src = a.thumb; } else { li.querySelector('img').remove(); }
    li.querySelector('strong').textContent = a.name;
    li.querySelector('.pc-result__text span').textContent = a.followers ? a.followers.toLocaleString('fr-FR') + ' abonnés' : 'Artiste';
    li.addEventListener('click', function () { self.showArtist(a); });
    this.list.appendChild(li);
  };

  PosterConfigurator.prototype.showFind = function (j) {
    var self = this, artists = j.artists || [], albums = j.albums || [];
    this.list.innerHTML = ''; this.active = -1;
    if (!artists.length && !albums.length) { this.addInfo('Aucun résultat'); return; }
    if (artists.length) { this.addHead('Artistes — tous leurs albums'); artists.forEach(function (a) { self.addArtist(a); }); }
    if (albums.length) { this.addHead('Albums'); albums.forEach(function (a) { self.addAlbum(a); }); }
  };

  PosterConfigurator.prototype.showArtist = function (a) {
    var self = this;
    var back = function () {
      var li = document.createElement('li');
      li.className = 'pc-result pc-result--back'; li.setAttribute('role', 'option');
      li.textContent = '← Résultats · ' + a.name;
      li.addEventListener('click', function () { var p = self.params(); if (p) { self.search(p); } else { self.closeList(); } });
      self.list.appendChild(li);
    };
    this.list.innerHTML = ''; this.active = -1; this.list.hidden = false;
    back(); this.addInfo('Chargement…');
    if (this.ctrl) { this.ctrl.abort(); }
    this.ctrl = new AbortController();
    fetch(this.api + '/api/artist/' + encodeURIComponent(a.id) + '/albums', { signal: this.ctrl.signal })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { throw new Error(j.error || j.detail || 'Erreur'); } return j; }); })
      .then(function (j) {
        self.list.innerHTML = ''; back();
        var results = j.results || [];
        if (!results.length) { self.addInfo('Aucun album trouvé'); return; }
        results.forEach(function (x) { self.addAlbum(x); });
      })
      .catch(function (err) {
        if (err.name === 'AbortError') { return; }
        self.closeList();
        self.say('Impossible de lister les albums : ' + err.message, true);
      });
  };

  PosterConfigurator.prototype.showResults = function (results) {
    var self = this;
    this.list.innerHTML = ''; this.active = -1;
    if (!results.length) { this.addInfo('Aucun album trouvé'); return; }
    results.forEach(function (a) { self.addAlbum(a); });
  };

  PosterConfigurator.prototype.closeList = function () { this.list.hidden = true; this.list.innerHTML = ''; this.active = -1; };

  PosterConfigurator.prototype.choose = function (a) {
    this.state.album = a;
    if (this.mode === 'double') { this.inputs.artist.value = a.artist; this.inputs.album.value = a.name; }
    else { this.inputs.q.value = a.artist + ' - ' + a.name; }
    this.$('[data-pc-selected-name]').textContent = a.name;
    this.$('[data-pc-selected-artist]').textContent = a.artist + (a.year ? ' · ' + a.year : '');
    var img = this.$('[data-pc-selected-img]');
    if (a.thumb) { img.src = a.thumb; img.hidden = false; } else { img.hidden = true; }
    this.selected.hidden = false;
    this.closeList(); this.say('');
    this.prefillSignature();
    this.refresh(true);
  };

  PosterConfigurator.prototype.reset = function (clearInputs) {
    this.state.album = null; this.selected.hidden = true;
    if (clearInputs) {
      Object.keys(this.inputs).forEach(function (k) { this.inputs[k].value = ''; }, this);
      this.closeList(); this.firstInput().focus();
    }
    this.say('');
    this.refresh();
  };

  /* ---------- code Spotify ou signature ---------- */
  PosterConfigurator.prototype.initMode = function () {
    var self = this, box = this.$('[data-pc-mode]'), input = this.$('[data-pc-sig-text]');
    if (!box || !input) { return; }
    box.addEventListener('change', function (e) {
      if (e.target.type !== 'radio') { return; }
      self.state.mode = e.target.value === 'signature' ? 'signature' : 'code';
      self.$('[data-pc-signature]').hidden = self.state.mode !== 'signature';
      if (self.state.mode === 'signature') { self.loadFonts(); self.prefillSignature(); }
      self.say('');
      self.refresh(false);
    });
    var timer = null;
    input.addEventListener('input', function () {
      self.sigTouched = true;                              // le client a écrit sa propre signature : on n'y touche plus
      var clean = input.value.replace(SIG_FORBIDDEN, '').replace(/ {2,}/g, ' ').replace(/^ /, '');   // même nettoyage que le serveur
      if (clean !== input.value) { input.value = clean; }
      self.state.sig = clean;
      self.say('');
      self.syncProperties();
      clearTimeout(timer);
      timer = setTimeout(function () { self.refresh(false); }, 700);     // on attend la fin de la frappe : un rendu serveur par pause
    });
  };

  /* Signature par défaut = nom de l'artiste de l'album choisi, modifiable. Une signature écrite par le client est conservée. */
  PosterConfigurator.prototype.prefillSignature = function () {
    var input = this.$('[data-pc-sig-text]'), a = this.state.album;
    if (!input || !a || this.sigTouched) { return; }
    var max = input.maxLength > 0 ? input.maxLength : 24;
    var name = (a.artist || '').replace(SIG_FORBIDDEN, '').replace(/ {2,}/g, ' ').trim().slice(0, max).trim();
    input.value = name;
    this.state.sig = name;
    var pv = this.$('[data-pc-sig-preview]');
    if (pv) { pv.textContent = name; }
    this.syncProperties();
  };

  PosterConfigurator.prototype.loadFonts = function () {
    var self = this;
    if (this.fontsLoaded) { return; }
    this.fontsLoaded = true;
    if (!this.fontChoice) {                                  // police unique : on charge juste celle-là pour le champ de saisie
      var one = self.$('[data-pc-sig-preview]') || self.$('[data-pc-sig-text]');
      if (one && window.FontFace) {
        var face = new FontFace('pc-' + this.fontDefault, 'url(' + this.api + '/api/fonts/' + encodeURIComponent(this.fontDefault) + '.ttf)');
        face.load().then(function () { document.fonts.add(face); one.style.fontFamily = '"pc-' + self.fontDefault + '", cursive'; }).catch(function () {});
      }
      return;
    }
    var render = function (fonts, remote) {
      var box = self.$('[data-pc-fonts]'); if (!box) { return; }
      box.querySelectorAll('button').forEach(function (b) { b.remove(); });
      fonts.forEach(function (f) {
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'pc-font'; btn.textContent = f.label;
        btn.setAttribute('aria-pressed', f.id === self.state.font ? 'true' : 'false');
        btn.addEventListener('click', function () {
          self.state.font = f.id;
          box.querySelectorAll('.pc-font').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          self.refresh(false);
        });
        // chaque nom s'écrit dans sa police ; tant qu'elle n'est pas chargée (ou si elle échoue) : écriture manuscrite du système
        if (remote && f.url && window.FontFace) {
          var face = new FontFace('pc-' + f.id, 'url(' + self.api + f.url + ')');
          face.load().then(function () { document.fonts.add(face); btn.style.setProperty('--pc-font', '"pc-' + f.id + '"'); }).catch(function () {});
        }
        box.appendChild(btn);
      });
      if (!fonts.some(function (f) { return f.id === self.state.font; })) { self.state.font = fonts[0].id; }
    };
    render(FALLBACK_SIG_FONTS, false);
    fetch(this.api + '/api/options').then(function (r) { return r.ok ? r.json() : null; }).then(function (o) {
      if (!o || !o.signature) { return; }
      var input = self.$('[data-pc-sig-text]');
      if (input && o.signature.max_length) { input.maxLength = o.signature.max_length; }
      if (o.signature.fonts && o.signature.fonts.length) { self.fontList = o.signature.fonts; render(o.signature.fonts, true); }
    }).catch(function () {});
  };

  /* ---------- couleur des 5 rectangles du bas ---------- */
  var hexNorm = function (h) { return '#' + h.replace('#', '').toLowerCase(); };
  var lum = function (hex) {
    var c = hex.replace('#', '');
    var v = [0, 2, 4].map(function (i) {
      var x = parseInt(c.substr(i, 2), 16) / 255;
      return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * v[0] + 0.7152 * v[1] + 0.0722 * v[2];
  };
  var contrast = function (a, b) {
    var la = lum(a), lb = lum(b);
    return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
  };

  PosterConfigurator.prototype.initBar = function () {
    var self = this, box = this.$('[data-pc-bar]');
    if (!box) { return; }
    var color = this.$('[data-pc-bar-color]'), hex = this.$('[data-pc-bar-hex]'), timer = null;
    color.addEventListener('change', function () { self.setSlot(color.value); });
    hex.addEventListener('input', function () {
      clearTimeout(timer);
      if (!HEX6.test(hex.value.trim())) { return; }
      timer = setTimeout(function () { self.setSlot(hex.value.trim()); }, 350);
    });
    var cv = this.$('[data-pc-bar-canvas]');
    if (cv) {
      var sample = function (e) {                             // couleur moyenne de 5 x 5 pixels sous le doigt (évite le grain)
        if (!cv._ok) { return null; }
        var r = cv.getBoundingClientRect();
        var x = Math.max(2, Math.min(cv.width - 3, Math.round((e.clientX - r.left) / r.width * cv.width)));
        var y = Math.max(2, Math.min(cv.height - 3, Math.round((e.clientY - r.top) / r.height * cv.height)));
        try {
          var d = cv.getContext('2d').getImageData(x - 2, y - 2, 5, 5).data, t = [0, 0, 0], n = d.length / 4, i;
          for (i = 0; i < d.length; i += 4) { t[0] += d[i]; t[1] += d[i + 1]; t[2] += d[i + 2]; }
          return '#' + t.map(function (v) { var h = Math.round(v / n).toString(16); return h.length < 2 ? '0' + h : h; }).join('');
        } catch (err) { return null; }
      };
      var live = function (e) {                               // pendant le glissement : seulement le champ, pas de rendu serveur
        var c = sample(e);
        if (c) { color.value = c; hex.value = c.toUpperCase(); }
        return c;
      };
      var down = false;
      cv.addEventListener('pointerdown', function (e) { down = true; cv.setPointerCapture && cv.setPointerCapture(e.pointerId); live(e); e.preventDefault(); });
      cv.addEventListener('pointermove', function (e) { if (down) { live(e); } });
      cv.addEventListener('pointerup', function (e) { if (!down) { return; } down = false; var c = live(e); if (c) { self.setSlot(c); } });
      cv.addEventListener('pointercancel', function () { down = false; });
    }
    this.$('[data-pc-bar-reset]').addEventListener('click', function () {
      self.state.bar = null; self.slot = null;
      self.renderBar(); self.refresh(false);
    });
  };

  /* Les couleurs par défaut (palette de la pochette) viennent du serveur : ce sont exactement celles de l'aperçu et du fichier d'impression. */
  PosterConfigurator.prototype.loadBar = function () {
    var self = this, s = this.state;
    if (this.kind === 'cover' || !this.$('[data-pc-bar]') || !s.album || !s.fond) { return; }
    var key = s.album.id + '|' + s.fond.id;
    if (this.barKey === key) { return; }
    this.barKey = key; s.barDefault = null;
    fetch(this.api + '/api/bar?album=' + encodeURIComponent(s.album.id) + '&fond=' + encodeURIComponent(s.fond.id))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (self.barKey !== key) { return; }
        s.barDefault = j && j.colors ? j.colors.map(hexNorm) : null;
        self.renderBar();
        self.syncProperties();
      }).catch(function () { if (self.barKey === key) { self.barKey = ''; } });
  };

  PosterConfigurator.prototype.effectiveBar = function () {
    return this.state.bar || this.state.barDefault;
  };

  PosterConfigurator.prototype.renderBar = function () {
    var self = this, s = this.state, box = this.$('[data-pc-bar]');
    if (!box) { return; }
    var cols = this.effectiveBar();
    box.hidden = !(s.album && s.fond && cols);
    if (box.hidden) { return; }
    var slots = this.$('[data-pc-bar-slots]');
    slots.innerHTML = '';
    cols.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pc-bar__slot'; b.style.background = c;
      b.setAttribute('aria-label', 'Rectangle ' + (i + 1) + ' : ' + c.toUpperCase());
      b.setAttribute('aria-pressed', self.slot === i ? 'true' : 'false');
      b.addEventListener('click', function () { self.slot = self.slot === i ? null : i; self.renderBar(); });
      slots.appendChild(b);
    });
    var editor = this.$('[data-pc-bar-editor]');
    editor.hidden = this.slot === null;
    if (this.slot !== null) {
      var cover = this.$('[data-pc-bar-cover]');
      if (cover) {
        if (s.album && s.album.thumb) { cover.src = s.album.thumb; cover.hidden = false; } else { cover.hidden = true; }
      }
      if (this.lastSlot !== this.slot && editor.scrollIntoView) {          // le sélecteur s'ouvre toujours dans la vue
        setTimeout(function () { editor.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 60);
      }
      var current = cols[this.slot];
      this.$('[data-pc-bar-color]').value = current;
      var hexInput = this.$('[data-pc-bar-hex]');
      if (document.activeElement !== hexInput) { hexInput.value = current.toUpperCase(); }
      this.drawCover();
    }
    this.lastSlot = this.slot;
    this.$('[data-pc-bar-reset]').hidden = !s.bar;
    // alerte (sans blocage) : un rectangle modifié presque de la couleur du fond disparaît à l'impression
    var warn = this.$('[data-pc-bar-warn]'), bg = s.fond && s.fond.bg, weak = false;
    if (s.bar && s.barDefault && bg && /^#[0-9a-f]{6}$/i.test(bg)) {
      s.bar.forEach(function (c, i) { if (c !== s.barDefault[i] && contrast(c, bg) < CONTRAST_MIN) { weak = true; } });
    }
    warn.hidden = !weak; warn.textContent = weak ? this.msgContrast : '';
  };

  /* Dessine la pochette (sans filigrane, en couleur) dans le canevas du sélecteur : servie par notre serveur, donc lisible en pixels. */
  PosterConfigurator.prototype.drawCover = function () {
    var cv = this.$('[data-pc-bar-canvas]'), s = this.state;
    if (!cv || !s.album || cv._album === s.album.id) { return; }
    cv._album = s.album.id; cv._ok = false;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      if (cv._album !== s.album.id) { return; }
      cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
      cv._ok = true;
    };
    img.src = this.api + '/api/cover/preview?album=' + encodeURIComponent(s.album.id) + '&version=color&width=600&plain=1';
  };

  PosterConfigurator.prototype.setSlot = function (value) {
    var s = this.state, base = this.effectiveBar();
    if (this.slot === null || !base || !HEX6.test(value)) { return; }
    var cols = base.slice();
    cols[this.slot] = hexNorm(value);
    var same = s.barDefault && cols.every(function (c, i) { return c === s.barDefault[i]; });
    s.bar = same ? null : cols;
    this.renderBar();
    this.refresh(false);
  };

  /* ---------- aperçus en direct ----------
     Galerie du thème : une image « aperçu à plat » en tête (data-apercu, posée par
     galerie-produit-scroll quand le réglage apercu_en_premier est actif), puis les
     3 premières photos de scène. Le poster généré s'affiche d'abord (rapide), les
     mises en scène arrivent ensuite, chacune sous un vinyle qui tourne. */
  /* Options de personnalisation du poster fiche, en paramètres d'URL (aperçu, mises en scène, configuration, impression). */
  var IMG_VERSION = 'p3';                                   // à changer pour forcer le rechargement des images déjà en cache navigateur

  PosterConfigurator.prototype.extraParams = function () {
    var s = this.state, q = '&v=' + IMG_VERSION;
    if (this.kind === 'cover') { return q; }
    if (s.mode === 'signature') { q += '&mode=signature&signature=' + encodeURIComponent(s.sig.trim()) + '&font=' + encodeURIComponent(s.font || ''); }
    if (s.bar) { q += '&bar=' + s.bar.map(function (c) { return c.replace('#', ''); }).join(','); }
    return q;
  };

  PosterConfigurator.prototype.previewUrl = function (width) {
    var s = this.state;
    if (this.kind === 'cover') { return this.api + '/api/cover/preview?album=' + encodeURIComponent(s.album.id) + '&version=' + encodeURIComponent(s.fond.id) + '&width=' + width + '&v=' + IMG_VERSION; }
    return this.api + '/api/preview?album=' + encodeURIComponent(s.album.id) + '&fond=' + encodeURIComponent(s.fond.id) + '&width=' + width + this.extraParams();
  };

  /* Le poster posé dans la scène photo n (1 cadre sur mur clair, 2 vue en angle, 3 gros plan) : mêmes images que les mockups du produit.
     size : échelle de la scène ; le coût du rendu est proportionnel au nombre de pixels. */
  PosterConfigurator.prototype.mockupUrl = function (n, size) {
    var s = this.state;
    if (this.kind === 'cover') { return this.api + '/api/cover/mockup?album=' + encodeURIComponent(s.album.id) + '&version=' + encodeURIComponent(s.fond.id) + '&n=' + n + '&size=' + size + '&v=' + IMG_VERSION; }
    return this.api + '/api/mockup?album=' + encodeURIComponent(s.album.id) + '&fond=' + encodeURIComponent(s.fond.id) + '&n=' + n + '&size=' + size + this.extraParams();
  };

  PosterConfigurator.prototype.targets = function () {
    var out = { apercu: null, mockups: [] };
    document.querySelectorAll('.galerie-produit__item').forEach(function (item) {
      var img = item.querySelector('img');
      if (!img) { return; }
      if (item.hasAttribute('data-apercu')) { out.apercu = { item: item, img: img }; }
      else if (out.mockups.length < 3) { out.mockups.push({ item: item, img: img }); }
    });
    return out;
  };

  PosterConfigurator.prototype.saveOrig = function (t) {
    if (!t.img._pcOrig) {
      t.img._pcOrig = { src: t.img.getAttribute('src'), srcset: t.img.getAttribute('srcset'), sizes: t.img.getAttribute('sizes'), alt: t.img.alt, zoom: t.item.getAttribute('data-zoom-src') };
    }
  };

  PosterConfigurator.prototype.show = function (t, url, alt) {
    t.img.removeAttribute('srcset'); t.img.src = url; t.img.alt = alt;
    t.item.setAttribute('data-zoom-src', url);
  };

  PosterConfigurator.prototype.restoreOne = function (t) {
    var o = t.img._pcOrig;
    t.item.classList.remove('pc-loading'); t.item.removeAttribute('data-pc-label');
    if (!o) { return; }
    t.img.src = o.src;
    if (o.srcset) { t.img.srcset = o.srcset; } else { t.img.removeAttribute('srcset'); }
    if (o.sizes) { t.img.sizes = o.sizes; }
    t.img.alt = o.alt;
    if (o.zoom) { t.item.setAttribute('data-zoom-src', o.zoom); } else { t.item.removeAttribute('data-zoom-src'); }
    delete t.img._pcOrig;
  };

  PosterConfigurator.prototype.restoreGallery = function () {
    var g = this.targets();
    if (g.apercu) { this.restoreOne(g.apercu); }
    g.mockups.forEach(this.restoreOne, this);
    this.$('[data-pc-fallback]').hidden = true;
  };

  PosterConfigurator.prototype.load = function (url, ok, ko) {
    var probe = new Image();
    probe.onload = ok; probe.onerror = ko;
    probe.src = url;
  };

  /* Téléphone : la galerie est en haut de page et le formulaire dessous. Une fois l'album
     (ou le fond) choisi, on ramène la vue sur le poster pour qu'il soit vu sans chercher. */
  PosterConfigurator.prototype.focusPreview = function () {
    if (!window.matchMedia('(max-width: 749px)').matches) { return; }
    var gal = document.querySelector('galerie-produit');
    if (!gal) { return; }
    if (document.activeElement && document.activeElement.blur) { document.activeElement.blur(); }   // ferme le clavier
    var vp = gal.querySelector('.galerie-produit__viewport');
    if (vp && vp.scrollTo) { vp.scrollTo({ left: 0, behavior: 'smooth' }); }
    var header = document.querySelector('.section-header');
    var offset = header ? header.getBoundingClientRect().height : 0;
    var top = gal.getBoundingClientRect().top + window.pageYOffset - offset - 8;
    if (Math.abs(top - window.pageYOffset) > 40) { window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' }); }
  };

  PosterConfigurator.prototype.refresh = function (focus) {
    var s = this.state, self = this;
    clearInterval(this.ticker);
    if (!s.album || !s.fond) { this.root.classList.remove('is-loading'); this.pending = null; this.progress(0, 0); this.restoreGallery(); this.renderBar(); this.syncProperties(); return; }
    this.loadBar();
    this.syncProperties();
    var token = {}, g = this.targets(), ts = g.mockups, ap = g.apercu, alt = 'Poster ' + s.album.name + ' - ' + s.album.artist;
    this.pending = token;
    this.root.classList.add('is-loading');
    this.say(TXT.making);
    var flat = this.previewUrl(900);
    if (focus) { this.focusPreview(); }

    if (!ts.length && !ap) {                                // pas de galerie reconnue : aperçu simple sous le bloc
      this.progress(0, 1);
      this.load(flat, function () {
        if (self.pending !== token) { return; }
        var fb = self.$('[data-pc-fallback]'); fb.src = flat; fb.alt = alt; fb.hidden = false;
        self.root.classList.remove('is-loading'); self.progress(0, 0); self.flash(TXT.ready);
      }, function () {
        if (self.pending !== token) { return; }
        self.root.classList.remove('is-loading'); self.progress(0, 0);
        self.say('Impossible de générer l\'aperçu pour le moment. Réessayez dans un instant.', true);
      });
      return;
    }

    // Les 4 images (poster à plat + 3 mises en scène) sont demandées ensemble, le poster en premier. Elles s'affichent dans
    // l'ordre du tableau ORDRE, chacune dès que les précédentes sont affichées : le poster à plat ne peut plus apparaître
    // après une mise en scène, même quand le serveur termine un rendu avant l'autre. Sous chaque vinyle, une ligne dit
    // ce qui se prépare dans la case.
    var flatTarget = ap || ts[0];                           // sans emplacement dédié, le poster à plat patiente dans la 1re scène
    var names = { flat: flatTarget };
    ts.forEach(function (t, i) { names['m' + (i + 1)] = t; });
    var order = ORDRE.filter(function (n) { return names[n]; });
    Object.keys(names).forEach(function (n) { if (order.indexOf(n) === -1) { order.push(n); } });   // absent de ORDRE : en dernier
    var total = order.length, arrived = 0, shown = 0, flatShown = false, flatDone = false, t0 = Date.now();
    var settled = {}, next = 0;
    var label = function (t, text) { if (text) { t.item.setAttribute('data-pc-label', text); } else { t.item.removeAttribute('data-pc-label'); } };
    this.saveOrig(flatTarget);
    ts.forEach(function (t, i) { self.saveOrig(t); t.item.classList.add('pc-loading'); label(t, 'Mise en scène ' + (i + 1) + ' sur ' + ts.length); });
    flatTarget.item.classList.add('pc-loading');
    label(flatTarget, 'Votre poster arrive…');

    var status = function () {
      if (self.pending !== token) { clearInterval(self.ticker); return; }
      var slow = !arrived && Date.now() - t0 > 6000;
      self.progress(arrived, total);
      if (arrived >= total) {
        clearInterval(self.ticker);
        self.root.classList.remove('is-loading'); self.progress(0, 0);
        if (!shown && !flatShown) { self.say('Impossible de générer les aperçus pour le moment. Réessayez dans un instant.', true); } else { self.flash(TXT.ready); }
        return;
      }
      if (slow) { label(flatTarget, 'Le serveur démarre…'); }
      self.say(slow ? TXT.makingSlow
        : !flatDone ? TXT.making
        : 'Poster prêt · mises en scène ' + shown + ' sur ' + ts.length + '…');
    };
    this.ticker = setInterval(status, 1000);
    status();

    // `apply` : ce qu'il faut faire à l'écran pour cette image ; il ne s'exécute que lorsque son tour est venu.
    var settle = function (name, apply) {
      if (self.pending !== token) { return; }
      arrived++; settled[name] = apply;
      while (next < order.length && settled[order[next]]) { settled[order[next++]](); }
      status();
    };

    this.load(flat, function () {
      settle('flat', function () {
        flatDone = true; flatShown = true;
        self.show(flatTarget, flat, alt);
        if (ap) { ap.item.classList.remove('pc-loading'); label(ap, ''); }
      });
    }, function () {
      settle('flat', function () { flatDone = true; if (ap) { self.restoreOne(ap); } });
    });

    ts.forEach(function (t, i) {
      var url = self.mockupUrl(i + 1, 1.5);
      self.load(url, function () {
        settle('m' + (i + 1), function () {
          shown++;
          self.show(t, url, alt + ' (vue ' + (i + 1) + ')');
          t.item.classList.remove('pc-loading'); label(t, '');
        });
      }, function () {
        settle('m' + (i + 1), function () {
          if (flatTarget === t && flatShown) { t.item.classList.remove('pc-loading'); label(t, ''); } else { self.restoreOne(t); }
        });
      });
    });
  };

  /* ---------- propriétés de ligne dans le formulaire d'achat du thème ---------- */
  PosterConfigurator.prototype.stateKey = function () {
    var s = this.state;
    return s.album && s.fond ? [s.album.id, s.fond.id, this.kind, this.extraParams()].join('|') : '';
  };

  /* L'adresse d'impression signée et la configuration validée viennent du serveur (/api/config) : elles décrivent
     exactement ce que le fichier d'impression contiendra. Sans réponse du serveur, _config_json local reste inscrit. */
  PosterConfigurator.prototype.scheduleConfig = function () {
    var self = this;
    clearTimeout(this.cfgTimer);
    if (!this.stateKey() || this.cfgKey === this.stateKey()) { this.cfgTimer = null; return; }
    this.cfgTimer = setTimeout(function () { self.cfgTimer = null; self.fetchConfig(); }, 250);
  };

  PosterConfigurator.prototype.fetchConfig = function () {
    var self = this, s = this.state, key = this.stateKey();
    if (!key) { return Promise.resolve(); }
    if (this.cfgKey === key) { return this.cfgPromise || Promise.resolve(); }
    var url = this.api + '/api/config?album=' + encodeURIComponent(s.album.id) + '&fond=' + encodeURIComponent(s.fond.id) +
      '&kind=' + this.kind + this.extraParams();
    var p = fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (j && self.stateKey() === key) { self.cfg = j; self.cfgKey = key; self.syncProperties(); }
    }).catch(function () {}).then(function () { if (self.cfgPromise === p) { self.cfgPromise = null; } });
    this.cfgPromise = p;
    return p;
  };

  PosterConfigurator.prototype.configBusy = function () {
    var key = this.stateKey();
    return !!key && this.cfgKey !== key && (!!this.cfgTimer || !!this.cfgPromise);
  };

  PosterConfigurator.prototype.settleConfig = function () {
    clearTimeout(this.cfgTimer); this.cfgTimer = null;
    var wait = new Promise(function (resolve) { setTimeout(resolve, 5000); });   // jamais bloquer l'achat plus de 5 s
    return Promise.race([this.fetchConfig(), wait]);
  };

  PosterConfigurator.prototype.syncProperties = function () {
    var form = this.form(); if (!form) { return; }
    var s = this.state, props = {};
    if (s.album && s.fond) {
      props['properties[Album]'] = s.album.artist + ' - ' + s.album.name;
      props['properties[_album_id]'] = s.album.id;
      props['properties[_fond_id]'] = s.fond.id;
      props['properties[_apercu]'] = this.previewUrl(600);
      if (this.kind === 'cover') {
        props['properties[Version]'] = s.fond.label; props['properties[_kind]'] = 'cover';
      } else {
        var sig = s.mode === 'signature', fontLabel = s.font, i;
        var list = this.fontList || FALLBACK_SIG_FONTS;
        for (i = 0; i < list.length; i++) { if (list[i].id === s.font) { fontLabel = list[i].label; } }
        var cols = this.effectiveBar();
        props['properties[Fond]'] = s.fond.label;
        props['properties[Mode]'] = sig ? this.labels.signature : this.labels.code;
        if (sig) {
          props['properties[Texte de signature]'] = s.sig.trim();
          if (this.fontChoice) { props['properties[Police]'] = fontLabel; }   // police unique : pas de ligne « Police » pour le client
          props['properties[_signature_text]'] = s.sig.trim();
          props['properties[_signature_font]'] = s.font;
        }
        props['properties[Couleur des rectangles]'] = s.bar ? s.bar.map(function (c) { return c.toUpperCase(); }).join(' ') : this.labels.barAuto;
        if (cols) { props['properties[_color_hex]'] = cols.map(function (c) { return c.replace('#', ''); }).join(','); }
        props['properties[_kind]'] = 'fiche';
        props['properties[_spotify_uri]'] = 'spotify:album:' + s.album.id;
        var cfg = {
          v: 1, album_id: s.album.id, spotify_uri: 'spotify:album:' + s.album.id, kind: 'fiche', fond: s.fond.id,
          mode: s.mode, signature: sig ? s.sig.trim() : '', font: sig ? s.font : '',
          bar: cols ? cols.map(function (c) { return c.replace('#', ''); }) : null
        };
        if (this.cfg && this.cfgKey === this.stateKey()) {                 // version validée par le serveur
          cfg = this.cfg.config;
          if (this.cfg.print_url) { props['properties[_print_file_url]'] = this.cfg.print_url; }
        }
        props['properties[_config_json]'] = JSON.stringify(cfg);
      }
    }
    form.querySelectorAll('input[data-pc-prop]').forEach(function (el) { if (!(el.name in props)) { el.remove(); } });
    Object.keys(props).forEach(function (name) {
      var el = form.querySelector('input[data-pc-prop][name="' + name.replace(/"/g, '\\"') + '"]');
      if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = name; el.setAttribute('data-pc-prop', ''); form.appendChild(el); }
      el.value = props[name];
    });
    this.scheduleConfig();
  };

  document.querySelectorAll('[data-poster-configurator]').forEach(function (el) { new PosterConfigurator(el); });
})();
